module.exports = __webpack_public_path__ + "static/img/16.a9d4df8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/16.jpg
// module id = oqjg
// module chunks = 1